import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StatusScreen } from '../../../../components';
import { ROUTES } from '../../../../routes/routes';
import { NotificationType, NotificationTypeEnum, StatusTypeEnum } from '../../../../types';

type InvitationAcceptedProps = {
  notification: NotificationType;
};

const InvitationAccepted: React.FC<InvitationAcceptedProps> = ({ notification }) => {
  const { t } = useTranslation('invitation');
  const navigate = useNavigate();
  const data = notification.data.type === NotificationTypeEnum.INVITATION ? notification.data : null;

  const onAccept = () => navigate(ROUTES.Root(), { replace: true });

  if (!data) return null;

  return (
    <StatusScreen
      header={t('accepted.title')}
      subTitle={t('accepted.message', { inviteeName: data.userName })}
      type={StatusTypeEnum.SHARE}
      secondaryBackground
      primaryBtnText={t('accepted.acceptInvitation')}
      onPrimaryBtnClick={onAccept}
    />
  );
};

export default InvitationAccepted;
